module.exports = __webpack_public_path__ + "r-v3/img/stopwatch_pause_rest.5d401874.svg";